import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import bannerChart from '../../../../assets/images/StockAnalysis/banner-chart.svg'
import iconArrowChart from '../../../../assets/images/StockAnalysis/icon-arrow-chart.svg'

import './ChartSolidgauge.scss'

export default function ChartSolidgauge() {
  const [rotateValue, setRotateValue] = useState({
    value: 150,
    color: '#ffffff',
    text: ''
  })
  const AStore = useSelector((state) => state?.AStore);
  const valueDscRanking = AStore?.Overview?.dscRanking ? Object.keys(AStore?.Overview?.dscRanking)[0] : ''

  useEffect(() => {
    let valueNew = 150
    let color = ''

    if (valueDscRanking === 'A') {
      valueNew = 150 + 0
      color = '#22ab24';
    } else if (valueDscRanking === 'B') {
      valueNew = 150 + -40;
      color = '#83c400';
    } else if (valueDscRanking === 'C') {
      valueNew = 150 + -80;
      color = '#ffc400';
    } else if (valueDscRanking === 'D') {
      valueNew = 150 + -120;
      color = '#ff4230';
    }
    
    setRotateValue({
      value: 150,
      color: '#ffffff',
      text: ''
    });
    setTimeout(() => {
      setRotateValue({
        value: valueNew,
        color: color,
        text: valueDscRanking
      })
    }, 1000)
  }, [valueDscRanking])


  if (rotateValue.value)
    return (
      <>
        <div className='rYHqKGivFb'>
          <div className='ULSkrzagzE' style={{ color: rotateValue.color }}>{rotateValue.text}</div>
          <div className='SUyojhxuio'><img src={bannerChart} alt="" className='rspihoqfqm' /></div>
          <div className='kcvdkrytnv' style={{ transform: `translateX(-50%) rotate(${rotateValue.value}deg)` }}>
            <img src={iconArrowChart} alt="" className='emjzkftgek' />
          </div>
        </div>
      </>
    )
}